import React from 'react';
import { FormGroup, FormLabel } from 'react-bootstrap';
import { MultiSelect } from 'react-multi-select-component';
import { useTheme } from 'styled-components';

import { StyledMultiSelectContainer } from './styles';
export type OptionType = {
  label: string;
  value: string;
};

interface CustomMultiSelectProps {
  id?: string;
  name?: string;
  title: string;
  value: OptionType[];
  options: OptionType[];
  onChange: (selected: OptionType[]) => void;
  required?: boolean;
  hasSelectAll?: boolean;
  disabled?: boolean;
  labelledBy?: string;
  overrideStrings?: Record<string, string>;
  style?: React.CSSProperties;
  'data-testid'?: boolean | string;
}

const CustomMultiSelect: React.FC<CustomMultiSelectProps> = ({
  id,
  name,
  title,
  value,
  options,
  onChange,
  required,
  hasSelectAll,
  disabled,
  labelledBy = 'Selecionar',
  overrideStrings,
  style,
  'data-testid': dataTestId,
}) => {
  const theme = useTheme();

  const controlId = id ?? name ?? title.toLowerCase().replace(/\s+/g, '-');

  const testId =
    typeof dataTestId === 'string'
      ? dataTestId
      : dataTestId === true
        ? `input-multiselect-${controlId}`
        : undefined;

  return (
    <FormGroup>
      <FormLabel
        style={{ color: theme.colors.textoAzul }}
        data-testid={testId ? `${testId}-label` : undefined}
      >
        {title}
        {required && <span style={{ color: theme.colors.vermelho }}> *</span>}
      </FormLabel>

      <StyledMultiSelectContainer style={style} data-testid={testId}>
        <MultiSelect
          options={options}
          value={value}
          onChange={onChange}
          hasSelectAll={hasSelectAll}
          disabled={disabled}
          labelledBy={labelledBy}
          overrideStrings={{
            selectSomeItems: 'Selecione...',
            allItemsAreSelected: 'Todos selecionados',
            noOptions: 'Nenhuma opção disponível',
            search: 'Buscar...',
            ...overrideStrings,
          }}
        />
      </StyledMultiSelectContainer>
    </FormGroup>
  );
};

export default CustomMultiSelect;
